import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const farmDailyLogView = createAsyncThunk('farmDailyLogView', async ({ logId, navigate }) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `farm_log_view/${logId}`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": SessionManager.getCookie("user_token"),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const farmDailyLogViewSlice = createSlice({
    name: 'farmDailyLogView',
    initialState: {
        data: '',
    },
    reducers: {
        clearFarmDailyLogView: (state) => {
            state.data = ''
        },
    },
    extraReducers: (builder) => {
        builder.addCase(farmDailyLogView.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const body = action.payload.data
                state.data = body?.data ?? ''
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
                state.data = ''
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
                state.data = ''
            } else {
                state.data = ''
            }
        });
        builder.addCase(farmDailyLogView.rejected, (state) => {
            state.data = ''
        })
    }
})

export const { clearFarmDailyLogView } = farmDailyLogViewSlice.actions
export default farmDailyLogViewSlice.reducer;
